import { useContext as t } from "react";
import { LocaleContext as r } from "./context3.mjs";
import { isDefined as c } from "./types3.mjs";
function u(e) {
  const { localeValues: o } = t(r);
  if (!o)
    throw Error("cant use Locale outside of LocaleContext!");
  return c(e) ? o[e] : o;
}
export {
  u as useLocale
};
//# sourceMappingURL=useLocale.mjs.map
